/** Client reports that are dev-tool noise or expected HTTP validation, not product bugs. */
export function isIgnorableClientReport(input: {
  message?: string | null
  stack?: string | null
  statusCode?: number | null
}): boolean {
  const message = input.message || ''
  const stack = input.stack || ''
  if (message.startsWith('[vite]') || message.includes('Failed to reload /')) return true
  if (stack.includes('@vite/client') || stack.includes('virtual:nuxt:')) return true
  // Vue hydration warnings are noisy in production logs and rarely actionable as "bugs".
  if (message.includes('Hydration completed but contains mismatches')) return true
  if (message.includes('Hydration text mismatch') || message.includes('Hydration node mismatch')) return true
  const code = input.statusCode
  if (typeof code === 'number' && code >= 400 && code < 500) return true
  return false
}

export function statusCodeOf(error: unknown): number | null {
  if (!error || typeof error !== 'object') return null
  const record = error as { statusCode?: unknown; status?: unknown }
  const code = record.statusCode ?? record.status
  return typeof code === 'number' ? code : null
}
